// Uncomment the below to migrate to statefull component
// import ContentContainer from './ContentContainer'
import Content from './Content'

export { Content }
export default Content
// Uncomment the below to migrate to statefull component
// export { ContentContainer }
// export default { ContentContainer }



// WEBPACK FOOTER //
// ./src/pages/Content/index.js